import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { blue, grey, orange } from "@mui/material/colors";
import React from "react";

function MetricsRow({
  metricText,
  autoValue,
  fireValue,
  autoSubText,
  fireSubText,
}) {
  return (
    <TableRow>
     
      <TableCell sx={{ py: 0.5 }} align="center">
        <Stack direction="column" spacing={0}>
          <Typography sx={{ color: blue[900], fontWeight: 700, fontSize: 24 }}>
            {autoValue}
          </Typography>
          <Typography sx={{ color: grey[700], fontWeight: 400, fontSize: 16 }}>
            {autoSubText}
          </Typography>
        </Stack>
      </TableCell>
      <TableCell align="center" sx={{ py: 0 }}> <Typography sx={{ color: grey[900], fontWeight: 700, fontSize: 16 }}>{metricText}</Typography> </TableCell>
      <TableCell sx={{ py: 0 }} align="center">
        <Stack direction="column" spacing={0}>
          <Typography
            sx={{ color: orange[900], fontWeight: 700, fontSize: 24 }}
          >
            {fireValue}
          </Typography>
          <Typography sx={{ color: grey[700], fontWeight: 400, fontSize: 16 }}>
            {fireSubText}
          </Typography>
        </Stack>
      </TableCell>
    </TableRow>
  );
}

function CustomMetricsTable({
  autoSummary,
  fireSummary,
  totalAutoDocs,
  totalFireDocs,
  totalNumClaims,
}) {
  return (
    <TableContainer
      sx={{
        border: 2,
        borderColor: "lightgray",
        backgroundColor: "background.main",
        borderRadius: 3,
      }}
    >
      <Table size="small" aria-label="custom metrics table">
        <TableHead>
          <TableRow sx={{ bgcolor: "lightgrey", p: 1 }}>
            <TableCell sx={{ py: 0, borderBottom: 1, borderColor: "gray" }}>
              <Typography
                align="center"
                sx={{
                  py: 0.5,
                  fontSize: 16,
                  fontWeight: "bold",
                }}
              >
                Auto
              </Typography>
            </TableCell>
            <TableCell sx={{ py: 0, borderBottom: 1, borderColor: "gray" }}>
              <Typography
                align="center"
                sx={{
                  py: 0.5,
                  fontSize: 16,
                  fontWeight: "bold",
                }}
              >
                Metric
              </Typography>
            </TableCell>
            <TableCell sx={{ py: 0, borderBottom: 1, borderColor: "gray" }}>
              <Typography
                align="center"
                sx={{
                  py: 0.5,
                  fontSize: 16,
                  fontWeight: "bold",
                }}
              >
                Fire
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        <MetricsRow
            metricText="# of Claims with Similar Comparisons"
            autoValue={autoSummary.num_simulated_claims}
            fireValue={fireSummary.num_simulated_claims}
            autoSubText="Claims"
            fireSubText="Claims"
          />
          <MetricsRow
            metricText="AVG timespan of Claim"
            autoValue={autoSummary.avg_claim_timespan.toFixed(1)}
            fireValue={fireSummary.avg_claim_timespan.toFixed(1)}
            autoSubText="Days"
            fireSubText="Days"
          />
          <MetricsRow
            metricText="Total Number of Qualifying Comparisons"
            autoValue={autoSummary.sum_qualifying_comparisons.toLocaleString()}
            fireValue={fireSummary.sum_qualifying_comparisons.toLocaleString()}
            autoSubText="QCs"
            fireSubText="QCs"
          />
          <MetricsRow
            metricText="AVG Number of Qualifying Comparisons per Claim"
            autoValue={autoSummary.avg_qualifying_comparisons.toFixed(1)}
            fireValue={fireSummary.avg_qualifying_comparisons.toFixed(1)}
            autoSubText="QCs/Claim"
            fireSubText="QCs/Claim"
          />
          <MetricsRow
            metricText="Total Similar Comparisons generated for all Claims"
            autoValue={autoSummary.sum_claim_doc_pairs.toLocaleString()}
            fireValue={fireSummary.sum_claim_doc_pairs.toLocaleString()}
            autoSubText="Similar Comparisons"
            fireSubText="Similar Comparisons"
          />
          <MetricsRow
            metricText="AVG Number of Similar Comparisons per Claim"
            autoValue={autoSummary.avg_claim_doc_pairs.toFixed(1)}
            fireValue={fireSummary.avg_claim_doc_pairs.toFixed(1)}
            autoSubText="Similar Comparisons"
            fireSubText="Similar Comparisons"
          />
          <MetricsRow
            metricText="AVG Number of Pages per Similar Comparison"
            autoValue={autoSummary.avg_num_pages_per_pair.toFixed(1)}
            fireValue={fireSummary.avg_num_pages_per_pair.toFixed(1)}
            autoSubText="Pages"
            fireSubText="Pages"
          />
          <MetricsRow
            metricText="Total Number of Docs for all Claims"
            autoValue={totalAutoDocs.toLocaleString()}
            fireValue={totalFireDocs.toLocaleString()}
            autoSubText="Docs"
            fireSubText="Docs"
          />
          <MetricsRow
            metricText="Overall % of Docs that generate a Similar Comparison"
            autoValue={
              ((autoSummary.sum_claim_doc_pairs / totalAutoDocs) * 100).toFixed(
                3
              ) + "%"
            }
            fireValue={
              ((fireSummary.sum_claim_doc_pairs / totalFireDocs) * 100).toFixed(
                3
              ) + "%"
            }
            autoSubText={
              "(" +
              autoSummary.sum_claim_doc_pairs.toLocaleString() +
              " out of " +
              totalAutoDocs.toLocaleString() +
              ")"
            }
            fireSubText={
              "(" +
              fireSummary.sum_claim_doc_pairs.toLocaleString() +
              " out of " +
              totalFireDocs.toLocaleString() +
              ")"
            }
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default CustomMetricsTable;
